import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { OrderService } from '../services/order.service';
import { fromEvent, merge, Subject } from 'rxjs';

import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { IOrders } from '../interfaces/orders';
import { IOrder } from '../interfaces/order';
import { AppFormat } from '../appFormat';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SearchService } from '../services/search.service';
import { StoreService } from 'src/app/services/store.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { OperadorService } from '../services/operador.service';
import { IUsersystem } from '../interfaces/usersystem';

import { ExportExcelService } from '../services/export-excel.service';
import { ActivatedRoute } from '@angular/router';
import { HelperService } from '../services/helper.service';
import { CustomerService } from '../services/customer.service';
import { CouponService } from '../services/coupon.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
  host: { class: 'wrapper-order' },
  encapsulation: ViewEncapsulation.None,
})
export class OrderComponent implements OnInit {
  @ViewChild('searchFilter') searchFilter: ElementRef<HTMLDivElement>;

  private _document;

  public orders: IOrders;
  public order: IOrder;

  public num_pedente: number = 0;
  public num_separacao: number = 0;
  public num_lente: number = 0;
  public num_parcial: number = 0;
  public num_separado: number = 0;
  public num_rota_entrega: number = 0;
  public num_entrega: number = 0;
  public num_cancelado: number = 0;
  public openid: number = 0;

  public tab: string = 'pendente';

  private query;
  public page: number = 1;

  public open: boolean = false;
  public openInfo: boolean = false;
  public openProducts: boolean = false;

  public loading: boolean = false;
  public loadingOrder: boolean = false;
  public loadingDetail: boolean = false;

  public _destroy$: Subject<any>;

  private subscribeSearchFilter: Subscription;

  private subscribeSearch: Subscription;
  public search: string = '';
  private timeoutSearch = null;

  public optionOpen: boolean = false;
  public optionTimeout: any = null;

  selector: string = '.wrapper-order';

  public hasFilial: boolean = false;
  public listStores = [];
  public listOrderSituation = [];
  public listOrderSituationSelect = [];

  public listDatas = [];

  public showFilter: boolean = false;

  public entrega_nodia: FormControl;
  public pendente_nodia: FormControl;

  public atraso_sem: FormControl;
  public atraso_provavel: FormControl;
  public atraso_atrasado: FormControl;

  public isTryAnotherCapture: boolean = false;
  public isShowModal: boolean = false;
  public showModal: boolean = false;
  public showChangeStatus: boolean = false;
  public showAddPayment: boolean = false;
  public showTransfer: boolean = false;
  public idEstabelecimentoTransfer: number = null;
  public idpedidoSituacaoChange: number = null;

  public filterFrm: FormGroup;

  public dt_start: FormControl;
  public dt_end: FormControl;
  public tipo_data: FormControl;

  public idestabelecimento: FormControl;

  private operador: IUsersystem;
  public isAdmin: boolean = false;

  public isExportLoading: boolean = false;
  public isPrintLoading: boolean = false;
  public modalExportOpen: boolean = false;

  public showChangeSchedule: boolean = false;
  public startDate = new Date();
  public agendamento_data: any;
  public agendamento_hora: any;

  public showChangeDelivery: boolean = false;
  public loadingDelivery: boolean = false;
  public makeDelivery: boolean = false;
  public valorFrete: string;
  public idestabelecimentoEntrega: number;

  public idChangeDelivery = null;
  public objAddressDelivery = null;
  public stepChangeDelivery = 1;
  public listCustomerAddress = [];
  public addressOk = false;

  private logoData = null;
  private hasGetLogo: boolean = false;

  public isAntifraude: boolean = false;
  public antifraude: string = '';
  public isNeedConfirmToRelease: boolean = false;

  public showAddCupom: boolean = false;
  public ipt_cupom: string = '';
  public codigo_cupom: string = '';
  public lbl_list_cupons: string = '';
  public listCupons = [];
  

  public urlPayment: any = '';

  constructor(
    private _orderService: OrderService,
    private _searchService: SearchService,
    private _operadorService: OperadorService,
    private _exportExcelService: ExportExcelService,
    private _helperService: HelperService,
    private _storeService: StoreService,
    private _customerService: CustomerService,
    private _route: ActivatedRoute,
    private _couponService: CouponService,
    private _zone: NgZone,
    private sanitizer: DomSanitizer
  ) {
    this._destroy$ = new Subject();
    this.query = [];
    this.orders = { orders: [], total: [] };
    this.order = {
      idpedido: 0,
      nome: '',
    };
    this.loading = true;

    this.subscribeSearch = this._searchService._searchOrder.subscribe((res) => {
      this.search = res;
      if (this.timeoutSearch) clearTimeout(this.timeoutSearch);

      this.timeoutSearch = setTimeout(() => {
        this.closeDetail();
        this.changeTab('pendente');
      }, 300);
    });

    this.subscribeSearchFilter = this._searchService._searchFilter.subscribe(
      (res) => {
        if (res.action == 'order') {
          console.log(screen.width);
          if (screen.width > 500) {
            this.searchFilter.nativeElement.style.width =
              res['payload']['target']['offsetLeft'] + 26 + 'px';
          }

          this._document = document.getElementsByTagName('body');

          //roda fora do sistema de atualizacao do angular. melhora a otimizacao
          this._zone.runOutsideAngular(() => {
            merge(
              fromEvent(this._document, 'touchstart', { capture: true }),
              fromEvent(this._document, 'mousedown', { capture: true })
            )
              .pipe(takeUntil(this._destroy$))
              .subscribe(($event) => this._checkToClose($event));
          });

          this.showFilter = true;
        }
      }
    );
  }

  _checkToClose($event) {
    if (this.searchFilter.nativeElement.contains($event.target)) {
      return;
    }

    /** @type {?} */
    const path = $event.path || ($event.composedPath && $event.composedPath());
    if (
      $event.target &&
      $event.target.shadowRoot &&
      path &&
      path[0] &&
      this.searchFilter.nativeElement.contains(path[0])
    ) {
      return;
    }

    let dtcalendar = document.getElementsByClassName(
      'cdk-overlay-container'
    )[0];

    if (dtcalendar && dtcalendar.contains(path[0])) {
      return;
    }

    if (path[0].classList.contains('cdk-overlay-backdrop')) {
      return;
    }

    //como este código roda fora do sistema de alteração do angular. é preciso enviar o comando para o angular
    this._zone.run(() => {
      this.showFilter = false;
    });
  }

  ngOnDestroy(): void {
    this.subscribeSearch.unsubscribe();
    this.subscribeSearchFilter.unsubscribe();

    this._destroy$.next();
    this._destroy$.complete();
    this._destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.isExportLoading = false;
    this.modalExportOpen = false;

    this.isTryAnotherCapture = false;

    this.showFilter = false;
    this.operador = this._operadorService.getOperador();
    this.isAdmin = this.operador.sc_tipo == 'A';

    this.closeModal();

    this.hasFilial =
      this.operador.estabelecimento['filiais'] &&
      this.operador.estabelecimento['filiais'].length > 0;
    this.listStores = [];
    this.listOrderSituation = [];
    this.listOrderSituationSelect = [];

    if (this.hasFilial) {
      this.listStores.push(this.operador.estabelecimento);
      this.listStores = this.listStores.concat(
        this.operador.estabelecimento['filiais']
      );
    }

    this.listDatas = [
      {
        id: 'agendamento',
        label: 'Agendamento',
      },
      {
        id: 'criacao',
        label: 'Criação',
      },
      {
        id: 'pendentes',
        label: 'Pendentes',
      },
      {
        id: 'entregue',
        label: 'Entregue',
      },
      {
        id: 'pagamento',
        label: 'Pagamento',
      },
    ];

    this.createFormControls();
    this.createForm();

    this.changeTab('pendente');

    this._route.queryParams.subscribe((data) => {
      if (data['id'] !== undefined) {
        this.openDetail(
          {
            idpedido: parseInt(data['id']),
            nome: '',
          },
          0
        );
      }
    });
  }

  createFormControls() {
    this.dt_start = new FormControl(null);
    this.dt_end = new FormControl(null);
    this.idestabelecimento = new FormControl(null);

    this.tipo_data = new FormControl('criacao');

    this.entrega_nodia = new FormControl(false);
    this.pendente_nodia = new FormControl(false);

    this.atraso_sem = new FormControl(false);
    this.atraso_provavel = new FormControl(false);
    this.atraso_atrasado = new FormControl(false);
  }

  createForm() {
    this.filterFrm = new FormGroup({
      dt_start: this.dt_start,
      dt_end: this.dt_end,
      idestabelecimento: this.idestabelecimento,
      entrega_nodia: this.entrega_nodia,
      pendente_nodia: this.pendente_nodia,
      atraso_sem: this.atraso_sem,
      atraso_provavel: this.atraso_provavel,
      atraso_atrasado: this.atraso_atrasado,
      tipo_data: this.tipo_data,
    });
  }

  onExport() {
    this.isExportLoading = true;
    setTimeout(() => {
      this.modalExportOpen = true;
    }, 100);

    //let idpedido_situacao = this.query['idpedido_situacao']
    //delete this.query['idpedido_situacao']

    let page = this.query['page'];

    this.query['page'] = 'all';

    this._orderService.orders(this.query).subscribe((data) => {
      let orders = data.orders;

      let itens = [];
      let fields = data.fields_export;

      if (orders.length > 0) {
        for (let i in orders) {
          if (orders[i]['distancia'] != '') {
            orders[i]['distancia'] = this.formatDistance(
              orders[i]['distancia']
            );
          }

          switch (orders[i].idpedido_situacao) {
            case 1:
            case 2:
            case 9:
              orders[i]['situacao'] = 'pendente';
              break;
            case 3:
              orders[i]['situacao'] = 'separacao';
              break;
            case 4:
            case 5:
            case 6:
              orders[i]['situacao'] = 'separado';
              break;
            case 7:
              orders[i]['situacao'] = 'rota_entrega';
              break;
            case 8:
              orders[i]['situacao'] = 'entrega';
              break;
            case 10:
              orders[i]['situacao'] = 'cancelado';
              break;
            case 11:
              orders[i]['situacao'] = 'lente';
              break;
            case 12:
              orders[i]['situacao'] = 'parcial';
              break;

          }

          if (orders[i]['promotions'] && orders[i]['promotions'].length > 0) {
            let promotions = [];
            for (let j in orders[i]['promotions']) {
              promotions.push(orders[i]['promotions'][j]['descricao']);
            }
            orders[i]['promocoes'] = promotions.join(', ');
          }

          let item = {};

          for (let j in fields) {
            item[fields[j]] = orders[i][fields[j]];
          }

          itens.push(item);
        }

        let dataForExcel = [];

        itens.forEach((row: any) => {
          dataForExcel.push(Object.values(row));
        });

        let title = 'Pedidos';

        if (this.dt_start.value != null) {
          if (typeof this.dt_start.value === 'object') {
            title += ' ' + this.dt_start.value.format('DD-MM-YYYY');
          } else if (this.dt_start.value != null) {
            title += ' ' + this.dt_start.value;
          }
        }

        if (this.dt_end.value != null) {
          if (typeof this.dt_end.value === 'object') {
            title += ' ' + this.dt_end.value.format('DD-MM-YYYY');
          } else {
            title += ' ' + this.dt_end.value;
          }
        }

        let reportData = {
          title: title,
          data: dataForExcel,
          headers: Object.keys(itens[0]),
          monetary: ['M', 'N', 'O', 'P', 'Q'],
        };

        this._exportExcelService.exportExcel(reportData);
      } else {
        Swal.fire(
          'Ops!',
          'Não há nenhuma informação para ser exportada. Selecione outro filtro!',
          'error'
        );
      }

      this.modalExportOpen = false;
      setTimeout(() => {
        this.isExportLoading = false;
      }, 300);

      this.query['page'] = page;
      //this.query['idpedido_situacao'] = idpedido_situacao
    });
  }

  onClearFilter() {
    this.idestabelecimento.setValue(null);
    this.dt_end.setValue(null);
    this.dt_start.setValue(null);
    this.tipo_data.setValue('criacao');

    this.entrega_nodia.setValue(false);
    this.pendente_nodia.setValue(false);
    this.atraso_sem.setValue(false);
    this.atraso_provavel.setValue(false);
    this.atraso_atrasado.setValue(false);

    this.onSubmitFilter();
  }

  onSubmitFilter() {
    this.changeTab(this.tab);
    this.showFilter = false;
  }

  toggleOptions(): void {
    this.optionOpen = !this.optionOpen;

    this.clearOptions();
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout);

      this.optionTimeout = setTimeout(() => {
        this.optionOpen = false;
      }, 2000);
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout);
  }
  gerarViaLab() {
    const {
      idpedido
    } = this.order;    
    window.open('https://venda.wotica.com.br/vialab.php?idpedido='+idpedido, '_blank').focus();;
  }
  gerarNota() {
    const {
      idpedido
    } = this.order;    
    window.open('https://venda.wotica.com.br/nota.php?idpedido='+idpedido, '_blank').focus();;
  }
  gerarPDF() {
    if (!this.hasGetLogo) {
      this.isPrintLoading = true;
      this.isExportLoading = true;
      this._storeService.logo().subscribe((dataUrl) => {
        this.logoData = dataUrl;
        if (dataUrl['success']) {
          this.mountPDF(dataUrl);
        } else {
          this.mountPDF(null);
        }
        this.isPrintLoading = false;
        this.isExportLoading = false;
        this.hasGetLogo = true;
      });
    } else {
      this.mountPDF(this.logoData);
    }
  }

  mountPDF(logo) {
    const {
      idpedido,
      nome,
      telefone,
      cpf,
      cpf_nota,
      logradouro,
      numero,
      bairro,
      complemento,
      cidade,
      cep,
      uf,
      pagamento,
      entrega,
      idcartao,
      subtotal,
      frete,
      desconto,
      total,
      taxa,
      distance,
      obs,
      nome_estabelecimento,
      nome_estabelecimento_curto,
      encontrou_tudo_procurava,
    } = this.order;

    let y = 0;
    let margemLeft = 10;
    let margemRight = 435;
    let fontName = 'times';
    let fontWeightBold = 'bold';
    let fontWeightNormal = 'normal';

    let documento = new jsPDF('p', 'px', 'a4');

    documento.setTextColor(0);
    documento.setFontSize(22);
    documento.setFont(fontName, fontWeightBold);
    y = 40;
    documento.text('Pedido #' + idpedido, margemLeft, y);
    documento.setLineWidth(0.1);
    y = 47;
    documento.line(margemLeft, y, margemRight, y);

    // ajuste do logo
    if (logo && logo['img'] && logo['height'] && logo['width']) {
      //
      let hMax = 36;
      let dff = 4000 / logo['height'];
      let wD = (logo['width'] * dff) / 100;

      documento.addImage(logo['img'], 'JPEG', margemRight - wD, 9, wD, hMax);
    }

    // coluna 1

    // 1
    documento.setTextColor(0);
    documento.setFontSize(13);
    documento.setFont(fontName, fontWeightBold);
    y = 64;
    documento.text('Informações do Pedido', margemLeft, y);

    let wCol1 = 180;
    let mCol = 5;
    let xCol2 = margemLeft + wCol1 + mCol;
    let wCol2 = margemRight - wCol1 - margemLeft - mCol;

    documento.setLineWidth(0.1);
    documento.setDrawColor(0);
    documento.rect(margemLeft, y + 3, wCol1, 44);

    documento.setFontSize(11);
    documento.setFont(fontName, fontWeightNormal);
    documento.text(
      'Loja: ' + nome_estabelecimento_curto,
      margemLeft + 3,
      y + 12
    );
    documento.text(
      'Tipo: ' + (entrega == 'S' ? 'Entrega' : 'Retirada') + ' Agendada',
      margemLeft + 3,
      y + 27
    );
    if (this.order.data_agendamento) {
      documento.text(
        'Data: ' +
          AppFormat.formatFullDate(this.order.data_agendamento, true) +
          ', ' +
          AppFormat.formatWeekName(this.order.data_agendamento),
        margemLeft + 3,
        y + 42
      );
    }

    documento.text(
      'Data: ' + AppFormat.formatFullDate(this.order.data, true),
      margemLeft + 110,
      y + 12
    );
    documento.text(
      (entrega == 'S' ? 'Frete: ' : 'Separação: ') +
        (frete == 0 || frete == null ? 'Grátis' : AppFormat.money(frete)),
      margemLeft + 110,
      y + 27
    );
    if (this.order.data_agendamento) {
      documento.text(
        'Hora: ' +
          AppFormat.simplyHour(
            AppFormat.formatHour(this.order.data_agendamento)
          ) +
          ' às ' +
          AppFormat.simplyHour(this.order.hora_final_agendamento),
        margemLeft + 110,
        y + 42
      );
    }

    documento.line(margemLeft, y + 17, margemLeft + wCol1, y + 17);
    documento.line(margemLeft, y + 32, margemLeft + wCol1, y + 32);

    documento.line(margemLeft + 107, y + 3, margemLeft + 107, y + 32);

    if (this.order['promotions'] && this.order['promotions'].length > 0) {
      y = y + 63;

      documento.setFontSize(13);
      documento.setFont(fontName, fontWeightBold);
      documento.text(
        this.order['promotions'].length > 1 ? 'Promoções' : 'Promoção',
        margemLeft,
        y
      );
      let promotions = '';
      for (let j in this.order['promotions']) {
        if (j != '0') promotions += ', ';
        promotions += this.order['promotions'][j]['descricao'];
      }

      var promotionsSplit = documento.splitTextToSize(promotions, wCol1 - 10, {
        fontSize: 11,
      });
      let promotionsHeight = documento.getTextDimensions(promotionsSplit, {
        fontSize: 11,
      });

      // console.log(obsHeight)
      documento.setFontSize(11);
      documento.setFont(fontName, fontWeightNormal);
      documento.text(promotions, margemLeft + 3, y + 5, {
        align: 'left',
        baseline: 'top',
        maxWidth: wCol1 - 10,
      });

      documento.rect(margemLeft, y + 3, wCol1, 5 + promotionsHeight.h);

      y += promotionsHeight.h - 35;
    }

    // 2

    let formaPagamento = '';
    let pagar = 'Na retirada';
    if (pagamento == 'O') {
      pagar = 'Pago online';

      formaPagamento =
        'Cartão: ' +
        (this.order.usuario_cartao && this.order.usuario_cartao.brand
          ? this.order.usuario_cartao.brand
          : '') +
        (this.order.usuario_cartao.tipo == 'D' ? ' débito' : ' crédito');
    } else {
      if (pagamento == 'E') {
        pagar = 'Na entrega';
      }
      if (idcartao == 0) {
        formaPagamento = 'Em dinheiro';
      } else if (this.order.cartao != undefined && this.order.cartao != null) {
        const { cartao } = this.order;
        if (cartao.tipo == 'C') {
          formaPagamento = ' crédito';
        } else if (cartao.tipo == 'D') {
          formaPagamento = ' débito';
        } else if (cartao.tipo == 'V') {
          formaPagamento = ' voucher de alimentação';
        } else if (cartao.tipo == 'A') {
          formaPagamento = ' com o aplicativo';
        }
        if (cartao.tipo == 'M') {
          formaPagamento = 'Em dinheiro';
        } else {
          formaPagamento = 'Cartão: ' + cartao.descricao + formaPagamento;
        }
      }
    }

    y = y + 60;

    documento.setFontSize(13);
    documento.setFont(fontName, fontWeightBold);
    documento.text('Pagamento', margemLeft, y);

    documento.setFontSize(11);
    documento.setFont(fontName, fontWeightNormal);
    documento.text('Forma de pagamento: ' + pagar, margemLeft + 3, y + 12);
    documento.text(formaPagamento, margemLeft + 3, y + 27);
    let yT = 0;
    if (taxa != null && taxa > 0) {
      documento.text(
        'Taxa venda online: ' + AppFormat.money(taxa),
        margemLeft + 3,
        y + 42
      );
      yT = 15;
    }
    let yD = 0;
    if (this.order['cupom_codigo'] != null) {
      documento.text(
        'Cupom de desconto: ' + this.order['cupom_codigo'],
        margemLeft + 3,
        y + 42 + yT
      );
      yD = 15;
    }
    documento.text(
      'Subtotal: ' + AppFormat.money(subtotal),
      margemLeft + 3,
      y + 42 + yT + yD
    );
    //+ (this.order['cupom_codigo'] != null ? this.order['cupom_codigo'] : '' )
    documento.text(
      'Descontos: ' + AppFormat.money(desconto),
      margemLeft + 90,
      y + 42 + yT + yD
    );

    documento.line(margemLeft, y + 17, margemLeft + wCol1, y + 17);
    documento.line(margemLeft, y + 32, margemLeft + wCol1, y + 32);
    if (taxa != null && taxa > 0) {
      documento.line(margemLeft, y + 47, margemLeft + wCol1, y + 47);
    }
    if (this.order['cupom_codigo'] != null) {
      documento.line(margemLeft, y + 47 + yT, margemLeft + wCol1, y + 47 + yT);
    }
    documento.line(
      margemLeft + 87,
      y + 32 + yT + yD,
      margemLeft + 87,
      y + 47 + yT + yD
    );

    documento.setDrawColor(0);
    documento.rect(margemLeft, y + 3, wCol1, 68 + yD);

    documento.setDrawColor(0);
    documento.setFillColor(200, 200, 200);
    documento.rect(margemLeft, y + 47 + yT + yD, wCol1, 24, 'FD');

    documento.setFont(fontName, fontWeightBold);
    documento.text(
      'Total a cobrar: ' + AppFormat.money(total),
      margemLeft + 90,
      y + 59 + yT + yD,
      { align: 'center', baseline: 'middle', maxWidth: wCol1 }
    );

    let yMax1 = y + 81 + yT + yD;

    // coluna 2

    // 1
    y = 64;

    documento.setFontSize(13);
    documento.text('Informações do Cliente', xCol2, y);

    let mCol2 = wCol2 / 2;
    documento.setFontSize(11);
    documento.setFont(fontName, fontWeightNormal);
    documento.text('Nome: ' + nome, xCol2 + 3, y + 12);
    documento.text(
      'Telefone: ' + (telefone ? telefone : ''),
      xCol2 + 3,
      y + 27
    );
    documento.text(
      (cpf && cpf.length == 14 ? 'CPF' : 'CNPJ') + ': ' + cpf,
      xCol2 + mCol2 + 3,
      y + 27
    );

    let endereco = 'Endereço: ' + logradouro + ', ' + numero;
    if (complemento != '' && complemento != null && complemento != 'null') {
      endereco += ', ' + complemento + ',';
    }
    endereco += ' Bairro ' + bairro + ' - ' + cidade + '/' + uf + ' - ' + cep;

    // let endereco = "Endereço: Rua Carlos Barbosa, 280, Rua Carlos Barbosa, 280, Bambuzal, Bairro Aparecida de Alvorada - Alvorada/RSAlvorada - 94850-230"
    var enderecoSplit = documento.splitTextToSize(endereco, wCol2, {
      fontSize: 11,
    });
    let enderecoHeight = documento.getTextDimensions(enderecoSplit, {
      fontSize: 11,
    });

    documento.text(endereco, xCol2 + 3, y + 34, {
      align: 'left',
      baseline: 'top',
      maxWidth: wCol2,
    });

    let loja =
      this.formatDistance(distance) + ' da loja ' + nome_estabelecimento;
    let lojaSplit = documento.splitTextToSize(loja, wCol1 - 10, {
      fontSize: 11,
    });
    let lojaHeight = documento.getTextDimensions(lojaSplit, { fontSize: 11 });

    documento.setFont(fontName, fontWeightBold);
    documento.text(
      loja,
      xCol2 + mCol2,
      y + enderecoHeight.h + 54 - lojaHeight.h / 2,
      { align: 'center', baseline: 'middle', maxWidth: wCol1 }
    );

    documento.line(xCol2, y + 17, xCol2 + wCol2, y + 17);
    documento.line(xCol2, y + 32, xCol2 + wCol2, y + 32);
    documento.line(xCol2 + mCol2, y + 17, xCol2 + mCol2, y + 32);
    documento.line(
      xCol2,
      y + enderecoHeight.h + 38,
      xCol2 + wCol2,
      y + enderecoHeight.h + 38
    );

    documento.rect(xCol2, y + 3, wCol2, 60 + enderecoHeight.h);

    // 2
    y = y + 78 + enderecoHeight.h;

    


    // coluna central
    y = y + 60 > yMax1 ? y + 60 : yMax1;
    let wFull = wCol1 + wCol2 + mCol;
    let mFull = wFull / 2;

    let encontrouHeight = null;
    let obsHeight = null;

    let observation = obs;

    if (cpf_nota != '' && cpf_nota != null) {
      if (!observation) {
        observation = '';
      } else {
        observation += '. ';
      }
      if (cpf_nota == cpf) {
        observation +=
          'Colocar o ' +
          (cpf.length == 14 ? 'CPF' : 'CNPJ') +
          ' do CLIENTE na nota fiscal';
      } else {
        observation +=
          'Colocar na nota fiscal o ' +
          (cpf_nota.length == 14 ? 'CPF:' : 'CNPJ:') +
          ' ' +
          cpf_nota +
          '';
      }
    }

    // let obsText = "Favor colocar o CPF na nota. Favor colocar o CPF na nota. Favor colocar o CPF na nota."
    if (observation) {
      var obsSplit = documento.splitTextToSize(observation, mFull - 10, {
        fontSize: 11,
      });
      obsHeight = documento.getTextDimensions(obsSplit, { fontSize: 11 });

      // console.log(obsHeight)
      documento.setFontSize(13);
      documento.setFont(fontName, fontWeightBold);
      documento.text('Observações do pedido', margemLeft + 3, y + 11);

      documento.setFontSize(11);
      documento.setFont(fontName, fontWeightNormal);
      documento.text(observation, margemLeft + 3, y + 14, {
        align: 'left',
        baseline: 'top',
        maxWidth: mFull - 10,
      });
    }
    // let encontrou_tudo_procurava = "No encontrei chuchu, quiabo e gengibre. No encontrei chuchu, quiabo e gengibre. No encontrei chuchu, quiabo e gengibre. No encontrei chuchu, quiabo e gengibre."
    if (encontrou_tudo_procurava) {
      let encontrouSplit = documento.splitTextToSize(
        encontrou_tudo_procurava,
        mFull - 10,
        { fontSize: 11 }
      );
      encontrouHeight = documento.getTextDimensions(encontrouSplit, {
        fontSize: 11,
      });

      // console.log(encontrouHeight)
      documento.setFontSize(13);
      documento.setFont(fontName, fontWeightBold);
      documento.text('Encontrou tudo que procurava?', mFull + 3, y + 11);

      documento.setFontSize(11);
      documento.setFont(fontName, fontWeightNormal);
      documento.text(encontrou_tudo_procurava, mFull + 3, y + 14, {
        align: 'left',
        baseline: 'top',
        maxWidth: mFull - 10,
      });
    }
    let hQuadro = 0;
    if (observation || encontrou_tudo_procurava) {
      hQuadro = 15;
      if (encontrouHeight && obsHeight) {
        if (encontrouHeight.h > obsHeight.h) {
          hQuadro += encontrouHeight.h;
        } else {
          hQuadro += obsHeight.h;
        }
      } else if (encontrouHeight) {
        hQuadro += encontrouHeight.h;
      } else if (obsHeight) {
        hQuadro += obsHeight.h;
      }
      hQuadro += 2;

      documento.setDrawColor(0);
      documento.rect(margemLeft, y, wFull, hQuadro);
      documento.line(mFull, y, mFull, y + hQuadro);

      hQuadro += 8;
    }

    // tabela
    y = y + hQuadro;

    documento.setFontSize(13);
    documento.setFont(fontName, fontWeightBold);
    documento.text('Descrição do Pedido', margemLeft, y + 11);

    y += 9;

    var headProducts = [
      ['Seq.', 'EAN', 'Descrição', 'Estoque', 'Valor Unit.', 'Qtd.', 'Total'],
    ];

    var bodyProducts = [];

    const { products } = this.order;

    var missing = [];
    var index = 0;
    for (let i in products) {
      let preco = products[i]['preco'];
      let preco_total = AppFormat.number(
        products[i]['preco'] * products[i]['quantidade']
      );
      let qtd = products[i]['quantidade'].toString();
      let estoque = '-';
      let descricao = products[i]['descricao'];

      if (this.onCheckAdds(products[i])) {
        descricao = '+ ' + descricao;
      }

      //
      if (products[i]['unid_venda'].toLowerCase() != 'kg') {
        if (
          products[i]['forma_venda'] &&
          products[i]['forma_venda'].toLowerCase() == 'kg'
        ) {
          //peso_liquido
          //unidade_peso_liquido

          // qtd = qtd + ' x ' + products[i]['peso_liquido'] + products[i]['unidade_peso_liquido'] + ' = ' + (parseFloat(qtd) * products[i]['peso_liquido']) + products[i]['unidade_peso_liquido']
          //qtd = (parseFloat(qtd) * products[i]['peso_liquido']) + products[i]['unidade_peso_liquido']
          // qtd = parseFloat(qtd).toString()

          let w = parseFloat(qtd) * products[i]['peso_liquido'];
          let peso = '';
          if (w > 1000) {
            peso = (w / 1000).toFixed(2) + 'Kg';
          } else {
            peso = w + products[i]['unidade_peso_liquido'];
          }
          // if (products[i]['quantidade'] != 1 ){
          descricao += ' (' + peso + ')';
          // }
        }

        qtd += ' un';
      }

      if (products[i]['unid_venda'].toLowerCase() == 'kg') {
        preco = products[i]['peso_preco'];
        preco_total = AppFormat.number(
          products[i]['peso_preco'] * products[i]['peso_qtd']
        );
        qtd = products[i]['peso_qtd'].toString() + ' Kg';
      }

      if (products[i]['preco_total'] && products[i]['preco_total'] > 0) {
        preco_total = AppFormat.number(products[i]['preco_total']);
      }

      if (products[i]['estoque'] > 0) {
        estoque = products[i]['estoque'].toString();
      }

      if (products[i]['isfree']) {
        preco = 'grátis';
        preco_total = 'grátis';
      } else {
        preco = AppFormat.number(preco);
      }

      if (products[i]['removido'] == 'N' && this.order.emfalta) {
        for (let j in this.order.emfalta) {
          if (
            this.order.emfalta[j]['for_idproduto_geral'] ==
            products[i]['idproduto_geral']
          ) {
            missing.push(index);
            index++;
            bodyProducts.push([
              index + '',
              this.order.emfalta[j]['codbarra'],
              this.order.emfalta[j]['descricao'],
              'em falta',
              '-',
              '-',
              '-',
            ]);
            break;
          }
        }
      }

      if (products[i]['removido'] == 'S') {
        missing.push(index);
        index++;
        bodyProducts.push([
          index + '',
          products[i]['codbarra'],
          descricao,
          'removido',
          '-',
          '-',
          '-',
        ]);
      } else {
        index++;
        bodyProducts.push([
          index + '',
          products[i]['codbarra'],
          descricao,
          estoque,
          preco,
          qtd,
          preco_total,
        ]);
      }

      if (
        products[i]['removido'] == 'N' &&
        this.order.products_discount &&
        this.order.products_discount.length > 0
      ) {
        for (let j in this.order.products_discount) {
          let prodd = this.order.products_discount[j];
          if (prodd['idproduto_geral'] == products[i]['idproduto_geral']) {
            index++;
            bodyProducts.push([
              index + '',
              products[i]['codbarra'],
              descricao,
              'desconto',
              prodd['valor'] ? '- ' + prodd['valor'] : '',
              prodd['qty'] ? prodd['qty'] + ' un' : '',
              '- ' + prodd['total'],
            ]);
            break;
          }
        }
      }
    }

    documento.autoTable({
      theme: 'grid',
      startY: y + 5,
      margin: 10,
      head: headProducts,
      body: bodyProducts,
      headStyles: {
        fillColor: '#CCCCCC',
        textColor: '#000000',
        lineColor: '#000000',
        lineWidth: 0,
        valign: 'middle',
        halign: 'center',
      },
      columnStyles: {
        0: {
          lineWidth: 0,
          lineColor: '#000000',
          cellWidth: 28,
          cellPadding: 0,
          valign: 'middle',
          halign: 'center',
        },
        1: {
          lineColor: '#000000',
          lineWidth: 0,
          cellWidth: 65,
          valign: 'middle',
          halign: 'center',
        },
        2: { lineColor: '#000000', lineWidth: 0 },
        3: {
          lineColor: '#000000',
          lineWidth: 0,
          cellWidth: 40,
          valign: 'middle',
          halign: 'center',
        },
        4: {
          lineColor: '#000000',
          lineWidth: 0,
          cellWidth: 48,
          valign: 'middle',
          halign: 'center',
        },
        5: {
          lineColor: '#000000',
          lineWidth: 0,
          cellWidth: 33,
          cellPadding: 0,
          valign: 'middle',
          halign: 'center',
        },
        6: {
          lineColor: '#000000',
          lineWidth: 0,
          cellWidth: 45,
          cellPadding: 0,
          valign: 'middle',
          halign: 'center',
        },
      },
      didParseCell: function (data) {
        var rows = data.table.body;
        if (data.section == 'body' && missing.includes(data.row.index)) {
          data.cell.styles.textColor = [255, 114, 114];
        }
      },
      didDrawCell: (data) => {
        documento.setDrawColor(0);
        data.doc.setLineWidth(0.1);

        if (data.section == 'head') {
          // header
          data.doc.line(
            data.cell.x,
            data.cell.y,
            data.cell.width + data.cell.x,
            data.cell.y
          );
        }

        data.doc.line(
          data.cell.x,
          data.cell.y,
          data.cell.x,
          data.cell.y + data.cell.height
        );

        if (data.column.index == 6) {
          data.doc.line(
            data.cell.width + data.cell.x,
            data.cell.y,
            data.cell.width + data.cell.x,
            data.cell.y + data.cell.height
          );
        }
      },
      didDrawPage: (data) => {
        documento.setDrawColor(0);
        data.doc.setLineWidth(1);
        data.doc.line(10, data.cursor.y, data.cursor.x, data.cursor.y);
      },
    });

    documento.output('dataurlnewwindow');
  }

  find() {
    this.query['page'] = this.page;

    this.loadingOrder = true;

    if (this.search != '') {
      this.query['search'] = this.search;
    } else {
      if (this.query['search']) {
        delete this.query['search'];
      }
    }

    this._orderService.orders(this.query).subscribe((data) => {
      this.orders.orders =
        this.page > 1 ? this.orders.orders.concat(data.orders) : data.orders;

      for (let i in this.orders.orders) {
        switch (this.orders.orders[i].idpedido_situacao) {
          case 1:
          case 2:
          case 9:
            this.orders.orders[i].tab = 'pendente';
            break;
          case 3:
            this.orders.orders[i].tab = 'separacao';
            break;
          case 4:
          case 5:
          case 6:
            this.orders.orders[i].tab = 'separado';
            break;
          case 7:
            this.orders.orders[i].tab = 'rota_entrega';
            break;
          case 8:
            this.orders.orders[i].tab = 'entrega';
            break;
          case 10:
            this.orders.orders[i].tab = 'cancelado';
            break;
          case 11:
            this.orders.orders[i].tab = 'lente';
            break;
          case 12:
            this.orders.orders[i].tab = 'parcial';
            break;
        }
      }

      if (data.total) {
        this.orders.total = data.total;
        for (let i in this.orders.total) {
          switch (this.orders.total[i].idpedido_situacao) {
            case 1:
            case 2:
            case 9:
              this.num_pedente += this.orders.total[i].num_pedidos;
              break;

            case 3:
              this.num_separacao += this.orders.total[i].num_pedidos;
              break;
            case 4:
            case 5:
            case 6:
              this.num_separado += this.orders.total[i].num_pedidos;
              break;
            case 7:
              this.num_rota_entrega += this.orders.total[i].num_pedidos;
              break;
            case 8:
              this.num_entrega += this.orders.total[i].num_pedidos;
              break;
            case 10:
              this.num_cancelado += this.orders.total[i].num_pedidos;
              break;
            case 11:
              this.num_lente += this.orders.total[i].num_pedidos;
              break;
            case 12:
              this.num_parcial += this.orders.total[i].num_pedidos;
              break;
          }
        }
      }
      this.loadingOrder = false;
      this.loading = false;
    });
  }

  onScroll() {
    if (!this.loadingOrder) {
      this.page = this.page + 1;
      this.find();
    }
  }

  changeTab(tab): void {
    this.loading = true;

    this.tab = tab;

    this.page = 1;

    this.num_pedente = 0;
    this.num_entrega = 0;
    this.num_separacao = 0;
    this.num_lente = 0;
    this.num_parcial = 0;
    this.num_separado = 0;
    this.num_rota_entrega = 0;
    this.num_cancelado = 0;

    delete this.query['idpedido_situacao'];
    delete this.query['entrega_nodia'];
    delete this.query['pendente_nodia'];
    delete this.query['atraso_sem'];
    delete this.query['atraso_provavel'];
    delete this.query['atraso_atrasado'];

    if (this.query['dtinicial']) delete this.query['dtinicial'];

    if (this.query['dtfinal']) delete this.query['dtfinal'];

    switch (tab) {
      case 'pendente':
        this.query['idpedido_situacao'] = '1,2,9';
        break;
      case 'separacao':
        this.query['idpedido_situacao'] = '3';
        break;
      case 'separado':
        this.query['idpedido_situacao'] = '4,5,6';
        break;
      case 'rota_entrega':
        this.query['idpedido_situacao'] = '7';
        break;
      case 'entrega':
        this.query['idpedido_situacao'] = '8';
        break;
      case 'cancelado':
        this.query['idpedido_situacao'] = '10';
        break;
      case 'lente':
        this.query['idpedido_situacao'] = '11';
        break;
      case 'parcial':
        this.query['idpedido_situacao'] = '12';
        break;
    }

    if (this.hasFilial) {
      this.query['idestabelecimento'] = 'all';
      if (
        this.idestabelecimento.value != null &&
        this.idestabelecimento.value > 0
      ) {
        this.query['idestabelecimento'] = this.idestabelecimento.value;
      }
    }

    //this.dt_inicial.setValue(AppFormat.dateYMDUTCMoment(dtinicial[0]))

    if (this.dt_start.value != null) {
      if (typeof this.dt_start.value === 'object') {
        this.query['dtinicial'] = this.dt_start.value.format('YYYY-MM-DD');
      } else if (this.dt_start.value != null) {
        this.query['dtinicial'] = this.dt_start.value;
      }
    }

    if (this.dt_end.value != null) {
      if (typeof this.dt_end.value === 'object') {
        this.query['dtfinal'] = this.dt_end.value.format('YYYY-MM-DD');
      } else {
        this.query['dtfinal'] = this.dt_end.value;
      }
    }

    this.query['tipo_data'] = this.tipo_data.value;

    if (this.entrega_nodia.value) {
      this.query['entrega_nodia'] = 'S';
    }
    if (this.pendente_nodia.value) {
      this.query['pendente_nodia'] = 'S';
    }
    //
    if (this.atraso_sem.value) {
      this.query['atraso_sem'] = 'S';
    }
    if (this.atraso_provavel.value) {
      this.query['atraso_provavel'] = 'S';
    }
    if (this.atraso_atrasado.value) {
      this.query['atraso_atrasado'] = 'S';
    }

    this.find();
  }

  tryAnotherCapture() {
    this.isTryAnotherCapture = true;

    this._orderService
      .tryAnotherCapture(this.order.idpedido)
      .subscribe((data) => {});
  }

  openDetail(order: IOrder, i: number) {
    this.open = true;
    this.order = order;
    this.openid = order.idpedido;

    this.isAntifraude = false;
    this.antifraude = '';
    this.ipt_cupom = '';

    this.loadingDetail = true;
    this.isTryAnotherCapture = false;

    this.isNeedConfirmToRelease = false;

    this._orderService.show(this.order.idpedido).subscribe((data) => {
      if (data['order']) {
        this.order = data['order'];

        if (this.order.pagamento == 'O') {
          this.order.canChangeDelivery = !(
            [4, 5, 6, 7, 8].indexOf(this.order.idpedido_situacao) > -1
          );
          this.order.canAddCoupon =
            !([4, 5, 6, 7, 8].indexOf(this.order.idpedido_situacao) > -1) &&
            this.order.cupom_codigo == null;
        } else {
          this.order.canChangeDelivery = !(
            [6, 7, 8].indexOf(this.order.idpedido_situacao) > -1
          );
          this.order.canAddCoupon = this.order.cupom_codigo == null;
        }

        if (this.order.transacoes) {
          for (let i in this.order.transacoes) {
            if (this.order.transacoes[i]['ds_antifraude']) {
              this.isAntifraude = true;
              this.antifraude = this.order.transacoes[i]['ds_antifraude'];
            }
          }
        }

        this.order.tab = order.tab;
        this.isNeedConfirmToRelease = this.order.requer_confirmacao == 'S';
      }

      this.loadingDetail = false;
    });
  }

  closeDetail() {
    this.open = false;
  }

  formatDistance(km) {
    return AppFormat.getDistance(km);
  }

  formatDuration(s) {
    return AppFormat.formatDuration(s);
  }

  getDay(d) {
    return AppFormat.getDay(d);
  }

  onTransfer() {
    if (this.idEstabelecimentoTransfer == null) {
      Swal.fire(
        'Ops!',
        'Selecione o estabelecimento que deseja transferir o pedido',
        'warning'
      );
    } else {
      Swal.fire({
        title: 'Você deseja realmente transferir o pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, desejo!',
        heightAuto: false,
      }).then((result) => {
        if (result.value) {
          this._orderService
            .transfer(this.order.idpedido, {
              idestabelecimento: this.idEstabelecimentoTransfer,
            })
            .subscribe((res) => {
              if (res['success']) {
                Swal.fire({
                  title: 'Sucesso!',
                  icon: 'success',
                  text: 'O pedido foi transferido!',
                  showCancelButton: false,
                  allowOutsideClick: true,
                  showConfirmButton: true,
                  heightAuto: false,
                });

                this.closeModal();
                this.closeDetail();
                this.changeTab(this.tab);
              } else {
                Swal.fire(
                  'Ops!',
                  'Ocorreu um erro ao tentar essa operação, error:[' +
                    res['error'] +
                    ']',
                  'error'
                );
              }
            });
        }
      });
    }
  }

  onChangeStatus() {
    if (this.idpedidoSituacaoChange == null) {
      Swal.fire(
        'Ops!',
        'Selecione a situação que deseja alterar no pedido',
        'warning'
      );
    } else {
      Swal.fire({
        title: 'Você deseja realmente mudar a situacão do pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, desejo!',
        heightAuto: false,
      }).then((result) => {
        if (result.value) {
          this._orderService
            .changeSituation(this.order.idpedido, {
              idpedido_situacao: this.idpedidoSituacaoChange,
            })
            .subscribe((res) => {
              if (res['success']) {
                Swal.fire({
                  title: 'Sucesso!',
                  icon: 'success',
                  text: 'A situação do pedido foi alterada!',
                  showCancelButton: false,
                  allowOutsideClick: true,
                  showConfirmButton: true,
                  heightAuto: false,
                });

                this.closeModal();
                this.closeDetail();
                this.changeTab(this.tab);
              } else {
                Swal.fire(
                  'Ops!',
                  'Ocorreu um erro ao tentar essa operação, error:[' +
                    res['error'] +
                    ']',
                  'error'
                );
              }
            });
        }
      });
    }
  }

  checkListSituation2Order() {
    if (
      this.order.pagamento == 'O' &&
      this.order.data_pedido_pronto != '' &&
      this.order.data_pedido_pronto != null
    ) {
      this.listOrderSituationSelect = [];
      for (let i in this.listOrderSituation) {
        if (
          ![1, 2, 3, 4, 9].includes(
            this.listOrderSituation[i].idpedido_situacao
          )
        ) {
          this.listOrderSituationSelect.push(this.listOrderSituation[i]);
        }
      }
    } else {
      this.listOrderSituationSelect = this.listOrderSituation;
    }
  }

  onShowChangeStatus() {
    if (this.listOrderSituation.length == 0) {
      this._helperService.getOrderSituation().subscribe((res) => {
        this.listOrderSituation = res;

        this.checkListSituation2Order();
      });
    } else {
      this.checkListSituation2Order();
    }

    this.idpedidoSituacaoChange = null;
    this.showChangeStatus = true;
    this.isShowModal = true;

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }
  onShowAddPayment() {
    let url = 'https://venda.wotica.com.br/add_pay.php?idpedido='+this.order.idpedido+'&total='+this.order.total;
    //this.urlPayment = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    this.urlPayment = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.showAddPayment = true;
    this.isShowModal = true;

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }
  ShowAddPayment() {
    
    //this.urlPayment = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost/pedido/add_pay.php');
  
    this.showAddPayment = true;
    this.isShowModal = true;

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }

  onShowTransfer() {
    this.idEstabelecimentoTransfer = null;
    this.showTransfer = true;
    this.isShowModal = true;

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }

  onShowSchedule() {
    this.showChangeSchedule = true;
    this.isShowModal = true;

    this.agendamento_data = null;
    this.agendamento_hora = null;

    if (this.order['data_agendamento']) {
      let dtinicial = this.order['data_agendamento'].split(' ');
      if (dtinicial.length > 0) {
        this.agendamento_data = AppFormat.dateYMDUTCMoment(dtinicial[0]);

        if (dtinicial.length > 1) {
          let horainicial = dtinicial[1].split(':');
          this.agendamento_hora = horainicial[0] + ':' + horainicial[1];
        }
      }
    }

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }

  onChangeSchedule() {
    let data_agendamento = '';
    if (
      this.agendamento_data != null &&
      typeof this.agendamento_data === 'object' &&
      this.agendamento_hora != '' &&
      this.agendamento_hora != null
    ) {
      data_agendamento = this.agendamento_data.format('YYYY-MM-DD');
      data_agendamento += ' ' + this.agendamento_hora + ':00';
    }

    if (data_agendamento == '') {
      Swal.fire(
        'Ops!',
        'Preencha uma data e hora para o agendamento',
        'warning'
      );
    } else {
      Swal.fire({
        title: 'Você deseja realmente mudar a data de agendamento do pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, desejo!',
        heightAuto: false,
      }).then((result) => {
        if (result.value) {
          this._orderService
            .changeSchedule(this.order.idpedido, {
              data_agendamento: data_agendamento,
            })
            .subscribe((res) => {
              if (res['success']) {
                Swal.fire({
                  title: 'Sucesso!',
                  icon: 'success',
                  text: 'A data do agendamento do pedido foi alterada!',
                  showCancelButton: false,
                  allowOutsideClick: true,
                  showConfirmButton: true,
                  heightAuto: false,
                });

                this.closeModal();
                this.closeDetail();
                this.changeTab(this.tab);
              } else {
                Swal.fire(
                  'Ops!',
                  'Ocorreu um erro ao tentar essa operação, error:[' +
                    res['error'] +
                    ']',
                  'error'
                );
              }
            });
        }
      });
    }
  }

  onManualRelease() {
    // onManualTransactionRelease
    this.isAntifraude = false;

    this._orderService
      .onManualTransactionRelease(this.order.idpedido)
      .subscribe((data) => {});
  }

  onConfirmRelease() {
    this.isNeedConfirmToRelease = false;

    this._orderService
      .confirmaRelease(this.order.idpedido)
      .subscribe((data) => {
        Swal.fire({
          title: 'Sucesso!',
          icon: 'success',
          text: 'O pedido foi autorizado!',
          showCancelButton: false,
          allowOutsideClick: true,
          showConfirmButton: true,
          heightAuto: false,
        });
      });
  }

  getLabelPreVenda() {
    if (this.order.codigo_interno == '0') {
      return 'Reenviando';
    } else {
      if (parseInt(this.order.codigo_interno) > 0) {
        return this.order.codigo_interno;
      } else {
        return 'Integrado';
      }
    }
  }

  reenviarPDV() {
    //
    Swal.fire({
      title: 'Você deseja realmente reenviar o PDV?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this._orderService.resendPDV(this.order.idpedido).subscribe((res) => {
          this.order.codigo_interno = '0';
          this.order.integrado = 'N';
          Swal.fire({
            title: 'Sucesso!',
            icon: 'success',
            text: 'O PDV será reenviado!',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            heightAuto: false,
          });
        });
      }
    });
  }

  onShowAddCupom() {
    this.codigo_cupom = null;
    this.showAddCupom = true;
    this.isShowModal = true;

    this.lbl_list_cupons = 'Procurando o cupom...';

    let param = {
      situacao: 'ativo',
      idestabelecimento: this.order.idestabelecimento,
    };

    if (this.ipt_cupom != '') {
      param['search'] = this.ipt_cupom;
    }

    // procura cupons disponiveis
    //
    this._couponService.search(param).subscribe((res) => {
      if (res.success) {
        this.listCupons = res.coupons;
        this.lbl_list_cupons = 'Selecione o cupom...';
      }
    });

    setTimeout(() => {
      this.showModal = true;
    }, 200);
  }

  findCupons() {
    this.onShowAddCupom();
  }

  onAddCupom() {
    if (this.codigo_cupom != null) {
      Swal.fire({
        title: 'Adicionando...',
        icon: 'info',
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      this._orderService
        .addCupom(this.order.idpedido, this.codigo_cupom)
        .subscribe((res) => {
          if (res['success']) {
            //recarrega os detalhes do pedido com novas informacoes da aplicação do cupom
            this.openDetail(this.order, 0);
            this.closeModal();
            Swal.fire({
              title: 'Sucesso!',
              icon: 'success',
              text: 'O cupom foi adicionado ao pedido!',
              showCancelButton: false,
              allowOutsideClick: true,
              showConfirmButton: true,
              heightAuto: false,
            });
          } else {
            Swal.fire(
              'Ops!',
              'Ocorreu um erro ao tentar essa operação, error:[' +
                res['error'] +
                ']',
              'error'
            );
          }
        });

      /*

      */
    }
  }

  closeModal() {
    this.showModal = false;
    this.showChangeStatus = false;
    this.showTransfer = false;
    this.showChangeSchedule = false;
    this.showChangeDelivery = false;
    this.showAddCupom = false;
    this.objAddressDelivery = null;
    this.ipt_cupom = '';

    setTimeout(() => {
      this.isShowModal = false;
    }, 200);
  }

  onShowDelivery() {
    if (this.order.entrega == 'N') {
      this.showChangeDelivery = true;
      this.isShowModal = true;

      this.loadingDelivery = true;
      this.makeDelivery = true;
      this.valorFrete = null;
      this.stepChangeDelivery = 1;
      if (this.objAddressDelivery == null) {
        this.objAddressDelivery = {
          logradouro: this.order.logradouro,
          numero: this.order.numero,
          complemento: this.order.complemento,
          bairro: this.order.bairro,
          cidade: this.order.cidade,
          uf: this.order.uf,
          cep: this.order.cep,
        };
        this.idChangeDelivery = this.order.idendereco;
      }

      this.checkDeliveryToAddress(this.idChangeDelivery);

      setTimeout(() => {
        this.showModal = true;
      }, 200);
    } else {
      this.onChangeDriveThru();
    }
  }

  checkDeliveryToAddress(id) {
    this._storeService
      .canDelivery(this.order.idestabelecimento, id)
      .subscribe((res) => {
        if (res['success']) {
          if (res['hasDelivery'] == false) {
            this.makeDelivery = false;
          } else {
            if (res['entregas'] && res['entregas'].length > 0) {
              this.valorFrete = res['entregas'][0]['valor'];
              this.idestabelecimentoEntrega =
                res['entregas'][0]['idestabelecimento_entrega'];
              this.makeDelivery = true;
            }
          }
        } else {
          //error
        }
        this.loadingDelivery = false;

        this.stepChangeDelivery = 1;
      });
  }

  changeAddressDelivery() {
    this.loadingDelivery = true;
    this.stepChangeDelivery = 2;
    this._customerService
      .listCustomerAddress(this.order.idusuario)
      .subscribe((res) => {
        if (res['success']) {
          this.listCustomerAddress = res['addresses'];
        }
        this.loadingDelivery = false;
      });
  }

  selectAddressDelivery(add) {
    this.loadingDelivery = true;
    this.idChangeDelivery = add['idendereco'];
    this.objAddressDelivery = add;
    this.checkDeliveryToAddress(this.idChangeDelivery);
  }

  addAddressCustomer() {
    this.objAddressDelivery = {
      logradouro: null,
      numero: null,
      complemento: null,
      bairro: null,
      cidade: null,
      uf: null,
      cep: null,
    };
    this.stepChangeDelivery = 3;
  }

  onCEPChange() {
    if (
      this.objAddressDelivery &&
      this.objAddressDelivery.cep &&
      this.objAddressDelivery.cep.length >= 8
    ) {
      this.loadingDelivery = true;
      this._helperService
        .findCEP(this.objAddressDelivery.cep)
        .subscribe((res) => {
          if (res.success) {
            if (res.localidades.length > 0) {
              let localidade = res.localidades[0];
              this.objAddressDelivery.logradouro = localidade['logradouro'];
              this.objAddressDelivery.complemento = localidade['complemento'];
              this.objAddressDelivery.bairro = localidade['bairro'];
              this.objAddressDelivery.cidade = localidade['localidade'];
              this.objAddressDelivery.uf = localidade['uf'];
            }
          } else {
            Swal.fire(
              'Ops!',
              'Não foi possível encontrar as informações para o CEP informado',
              'error'
            );
          }

          this.loadingDelivery = false;
        });
    }
  }

  onChangeAddress() {
    this.addressOk = true;
    if (
      this.objAddressDelivery.logradouro == null ||
      this.objAddressDelivery.logradouro == ''
    ) {
      this.addressOk = false;
      return false;
    }
    if (
      this.objAddressDelivery.bairro == null ||
      this.objAddressDelivery.bairro == ''
    ) {
      this.addressOk = false;
      return false;
    }
    if (
      this.objAddressDelivery.numero == null ||
      this.objAddressDelivery.numero == ''
    ) {
      this.addressOk = false;
      return false;
    }
  }

  onCheckAdds(p) {
    let found = false;
    for (let i in this.order.products_added) {
      if (
        this.order.products_added[i]['idproduto_geral'] == p['idproduto_geral']
      ) {
        found = true;
        break;
      }
    }

    return found;
  }

  saveAddressCustomer() {
    this.loadingDelivery = true;
    this._customerService
      .storeAddress(this.order.idusuario, this.objAddressDelivery)
      .subscribe((res) => {
        if (res['success']) {
          this.idChangeDelivery = res['idendereco'];
          this.checkDeliveryToAddress(this.idChangeDelivery);
        } else {
          Swal.fire(
            'Ops!',
            'Ocorreu um erro ao tentar essa operação!',
            'error'
          );
          this.loadingDelivery = false;
        }
      });
  }

  onChangeDelivery() {
    if (this.valorFrete == '' && !this.idChangeDelivery) {
      Swal.fire('Ops!', 'Preencha um valor para o frete', 'warning');
    } else {
      Swal.fire({
        title: 'Você deseja realmente mudar a forma de entrega do pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, desejo!',
        heightAuto: false,
      }).then((result) => {
        if (result.value) {
          this._orderService
            .changeToDelivery(this.order.idpedido, {
              idestabelecimento_entrega: this.idestabelecimentoEntrega,
              valor: this.valorFrete,
              idendereco: this.idChangeDelivery,
            })
            .subscribe((res) => {
              if (res['success']) {
                Swal.fire({
                  title: 'Sucesso!',
                  icon: 'success',
                  text: 'A forma de entrega do pedido foi alterada!',
                  showCancelButton: false,
                  allowOutsideClick: true,
                  showConfirmButton: true,
                  heightAuto: false,
                });

                this.closeModal();
                this.closeDetail();
                this.changeTab(this.tab);
              } else {
                Swal.fire(
                  'Ops!',
                  'Ocorreu um erro ao tentar essa operação, error:[' +
                    res['error'] +
                    ']',
                  'error'
                );
              }
            });
        }
      });
    }
  }

  onChangeDriveThru() {
    Swal.fire({
      title: 'Deseja alterar a forma de entrega para Drive-Thru?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this._orderService
          .changeToDriveThru(this.order.idpedido)
          .subscribe((res) => {
            if (res['success']) {
              Swal.fire({
                title: 'Sucesso!',
                icon: 'success',
                text: 'A forma de entrega do pedido foi alterada!',
                showCancelButton: false,
                allowOutsideClick: true,
                showConfirmButton: true,
                heightAuto: false,
              });

              this.closeModal();
              this.closeDetail();
              this.changeTab(this.tab);
            } else {
              Swal.fire(
                'Ops!',
                'Ocorreu um erro ao tentar essa operação, error:[' +
                  res['error'] +
                  ']',
                'error'
              );
            }
          });
      }
    });
  }
}
